
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/cloudnative/page/[id]",
      function () {
        return require("private-next-pages/cases/cloudnative/page/[id].tsx");
      }
    ]);
  